export default __webpack_public_path__ + "static/lockup_security_upgrade-3ae9e2e6800dcdeb20a1d990cb509eba.png";